module.exports = __webpack_public_path__ + "static/img/title-dpjs-new.2b3b566c.png";